import { render, staticRenderFns } from "./system-events.vue?vue&type=template&id=951ca4c6&"
import script from "./system-events.vue?vue&type=script&lang=js&"
export * from "./system-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports